var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('sm_header',{attrs:{"title":"酒店进程","smHleftEvent":_vm.closeWebview}}),_c('hotel-process',{attrs:{"orderInfo":_vm.orderList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }